import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleBasedRoute = ({ children, allowedRoles = [], requireAuth = true }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  // If authentication is required but user is not logged in
  if (requireAuth && !currentUser) {
    return <Navigate to="/login" />;
  }

  // If no role restrictions, just check authentication
  if (allowedRoles.length === 0) {
    return requireAuth ? (currentUser ? children : <Navigate to="/login" />) : children;
  }

  // Check if user has required role
  const userRole = currentUser?.role;
  const hasRequiredRole = allowedRoles.includes(userRole);

  if (!hasRequiredRole) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <p>Required roles: {allowedRoles.join(', ')}</p>
        <p>Your role: {userRole || 'None'}</p>
      </div>
    );
  }

  return children;
};

export default RoleBasedRoute;
